import VideoThumbnail from '@/data/VideoThumbnail';

export default class VideoThumbnailsMapper {

  public static mapFromObjectArray(videoThumbnailsArray: []): Array<VideoThumbnail> {

    if(videoThumbnailsArray.length === undefined) {
      throw new Error(`Can not map ${videoThumbnailsArray} to array of VideoThumbnail instances.`);
    }

    const thumbnails = new Array<VideoThumbnail>();
    for(const entry of videoThumbnailsArray) {
      const videoThumbnail = VideoThumbnailsMapper.mapFromObject(entry);
      if(videoThumbnail) {
        thumbnails.push(videoThumbnail);
      }
    }
    return thumbnails;
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  public static mapFromObject(videoThumbnailObj: any): VideoThumbnail {

    if(!videoThumbnailObj.id) {
      throw new Error(`Can not map ${videoThumbnailObj} to VideoThumbnail instance.`)
    }
    const videoThumbnail = new VideoThumbnail(videoThumbnailObj.id);
    if(!videoThumbnailObj.items || !videoThumbnailObj.items.length) {
      return videoThumbnail;
    }
    for(const item of videoThumbnailObj.items) {
      if(item.quality == 'thumbnail') {
        if(item.url) videoThumbnail.url = item.url;
        if(item.dimension) {
          if(item.dimension.width) videoThumbnail.width = item.dimension.width;
          if(item.dimension.height) videoThumbnail.height = item.dimension.height;
        }
      }
    }
    return videoThumbnail;
  }

}